import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { UserProfileService } from '../user-profile/user-profile.service';

@Injectable()
export class ProfileStoreService {
  private readonly RecentSelectionParameterSufix = '-STATYSTYKI_WYBORU';
  private readonly SelectedOrderParameterSufix = '-WYBRANE_SORTOWANIE';
  private readonly SelectedFiltersParameterSufix = '-WYBRANE_FILTRY';
  private readonly CertificatePasswordParameter = 'DANE_CERTYFIKATU';

  constructor(private userProfileService: UserProfileService) {}

  // TODO Zamienić na Promises

  restoreSelectionStats(attributeName: string): Observable<string> {
    const parameterName = this.formatRecentSelectionParameterName(attributeName);
    return this.userProfileService.loadValue(parameterName);
  }

  storeSelectionStats(attributeName: string, selectionStats: string): Observable<any> {
    const parameterName = this.formatRecentSelectionParameterName(attributeName);
    return this.userProfileService.saveValue(parameterName, selectionStats);
  }

  restoreSelectedOrder(dataViewName: string): Observable<string> {
    const parameterName = this.formatSelectedOrderParameterName(dataViewName);
    return this.userProfileService.loadValue(parameterName);
  }

  storeSelectedOrder(dataViewName: string, selectedOrder: string): Observable<string> {
    const parameterName = this.formatSelectedOrderParameterName(dataViewName);
    return this.userProfileService.saveValue(parameterName, selectedOrder);
  }

  restoreSelectedFilters(dataViewName: string): Observable<string> {
    const parameterName = this.formatSelectedFiltersParameterName(dataViewName);
    return this.userProfileService.loadValue(parameterName);
  }

  storeSelectedFilters(dataViewName: string, selectedFilters: string): Observable<any> {
    const parameterName = this.formatSelectedFiltersParameterName(dataViewName);
    return this.userProfileService.saveValue(parameterName, selectedFilters);
  }

  restoreCertificatePassword(): Observable<string> {
    return this.userProfileService.loadValue(this.CertificatePasswordParameter);
  }

  storeCertificatePassword(password: string): Observable<any> {
    return this.userProfileService.saveValue(this.CertificatePasswordParameter, password);
  }

  private formatRecentSelectionParameterName(attributeName: string): string {
    return attributeName + this.RecentSelectionParameterSufix;
  }

  private formatSelectedOrderParameterName(dataViewName: string): string {
    return dataViewName + this.SelectedOrderParameterSufix;
  }

  private formatSelectedFiltersParameterName(dataViewName: string): string {
    return dataViewName + this.SelectedFiltersParameterSufix;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/profile-store/profile-store.service.ts